import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableMember, NumberType } from '../../data/decorators';
import * as THREE from './_internal';
/**
 * Serializable THREE.js Vector3
 */
let Vector3 = class Vector3 extends THREE.Vector3 {
  static fromArray(array) {
    return new this().fromArray(array);
  }
  static fromVector(vector) {
    return new this(vector.x, vector.y, vector.z);
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector3.prototype, "x", void 0);
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector3.prototype, "y", void 0);
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector3.prototype, "z", void 0);
Vector3 = __decorate([SerializableObject()], Vector3);
export { Vector3 };